import * as React from "react";
import { useTheme } from "@/contexts/ThemeContext";
import { CloudMoon, Moon, Sun } from "phosphor-react";

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const [selectedTheme, setSelectedTheme] = React.useState<string>();

  React.useEffect(() => {
    setSelectedTheme(theme);
  }, [theme]);

  return (
    <div className="flex gap-1 rounded-full border p-1 text-center theme-border theme-card">
      <SwitchButton
        selectedTheme={selectedTheme}
        setTheme={setTheme}
        theme="system"
      >
        <CloudMoon color="currentColor" height={16} width={16} />
      </SwitchButton>
      <SwitchButton
        selectedTheme={selectedTheme}
        setTheme={setTheme}
        theme="light"
      >
        <Sun color="currentColor" height={16} width={16} />
      </SwitchButton>
      <SwitchButton
        selectedTheme={selectedTheme}
        setTheme={setTheme}
        theme="dark"
      >
        <Moon color="currentColor" height={16} width={16} />
      </SwitchButton>
    </div>
  );
}

function SwitchButton({
  selectedTheme,
  theme,
  setTheme,
  children,
}: {
  selectedTheme?: string;
  theme: 'dark' | 'light' | 'system';
  setTheme: (theme: 'dark' | 'light' | 'system') => void;
  children?: React.ReactNode;
}) {
  return (
    <button
      className="!flex !size-6 items-center justify-center rounded-full !p-[3px] text-neutral-500 dark:text-neutral-50 data-[selected='true']:bg-neutral-200 data-[selected='true']:text-neutral-500 dark:data-[selected='true']:bg-neutral-700 dark:data-[selected='true']:text-neutral-50 hover:bg-neutral-200 hover:text-neutral-500 dark:hover:bg-neutral-900 dark:hover:text-neutral-50"
      data-selected={selectedTheme === theme}
      onClick={() => setTheme(theme)}
    >
      {children}
    </button>
  );
}
